import { Collection, ModelBase, Property } from '@skylab-shared/core';
import { Dictionary } from '@skylab-shared/types';
import { DataExchangeKind, JpkVatSubkind, PackageOfDocumentsSubkind } from './data-exchange-kind';
import { PurchaseDocumentsDateSelectionKind } from './purchase-date-selection-kind';
import { SalesDocumentsDateSelectionKind } from './sales-date-selection-kind';
import { SentDocumentsFilteringPolicy } from './sent-documents-filtering-policy';


export class AccountancyModel extends ModelBase {
    @Property()
    public name: string;

    @Property({ nullable: true })
    public period_From: Date;

    @Property({ nullable: true })
    public period_To: Date;

    @Property()
    public salesDocumentsDateSelector: SalesDocumentsDateSelectionKind;

    @Property()
    public purchaseDocumentsDateSelector: PurchaseDocumentsDateSelectionKind;

    @Property()
    public sentDocumentsFiltering: SentDocumentsFilteringPolicy;

    @Collection({ type: Number, nullable: true })
    public objectIds: number[];

    @Property()
    public dataExchangeKind: DataExchangeKind;

    @Property(String, { nullable: true })
    public dataExchangeSubkind?: JpkVatSubkind | PackageOfDocumentsSubkind | null;

    @Property({ nullable: true })
    public parameters?: Dictionary<unknown> | null;
}
